import '@mui/material';
import { BreakpointsOptions } from '@mui/material';
import '@mui/material/styles';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true; // removes the `xs` breakpoint
    sm: true;
    md768: true;
    md: true;
    lg: true;
    lg1286: true;
    xl1440: true;
    xl: true;
  }
}

export const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 480,
    md768: 768,
    md: 1024,
    lg: 1200,
    lg1286: 1286,
    xl1440: 1440,
    xl: 1536,
  },
};
